import type { SVGProps } from 'react';
const DawnFlagTM = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-TM_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-TM_svg__a)">
      <path fill="#30C375" fillRule="evenodd" d="M0 16h22V0H0z" clipRule="evenodd" />
      <path fill="#DE414F" d="M3.143 0h3.143v16H3.143z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M4.714 3.2c.868 0 1.571-.478 1.571-1.067s-.703-1.066-1.571-1.066-1.571.477-1.571 1.066S3.846 3.2 4.714 3.2"
        clipRule="evenodd"
      />
      <mask
        id="dawn-flag-TM_svg__b"
        width={4}
        height={3}
        x={3}
        y={1}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M4.714 3.2c.868 0 1.571-.478 1.571-1.067s-.703-1.066-1.571-1.066-1.571.477-1.571 1.066S3.846 3.2 4.714 3.2"
          clipRule="evenodd"
        />
      </mask>
      <g mask="url(#dawn-flag-TM_svg__b)">
        <path
          fill="#DD404F"
          fillRule="evenodd"
          d="M4.714 2.667c.29 0 .524-.239.524-.534a.53.53 0 0 0-.524-.533.53.53 0 0 0-.524.533c0 .295.235.534.524.534"
          clipRule="evenodd"
        />
        <path
          fill="#FBAF29"
          d="M3.143 1.067h1.571v1.067H3.143zM4.714 2.133h1.571V3.2H4.714z"
        />
      </g>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M4.714 14.933c.868 0 1.571-.477 1.571-1.066S5.582 12.8 4.714 12.8s-1.571.478-1.571 1.067.703 1.066 1.571 1.066"
        clipRule="evenodd"
      />
      <mask
        id="dawn-flag-TM_svg__c"
        width={4}
        height={3}
        x={3}
        y={12}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M4.714 14.933c.868 0 1.571-.477 1.571-1.066S5.582 12.8 4.714 12.8s-1.571.478-1.571 1.067.703 1.066 1.571 1.066"
          clipRule="evenodd"
        />
      </mask>
      <g mask="url(#dawn-flag-TM_svg__c)">
        <path
          fill="#DD404F"
          fillRule="evenodd"
          d="M4.714 14.4c.29 0 .524-.239.524-.533a.53.53 0 0 0-.524-.534.53.53 0 0 0-.524.534c0 .294.235.533.524.533"
          clipRule="evenodd"
        />
        <path
          fill="#FBAF29"
          d="M3.143 12.8h1.571v1.067H3.143zM4.714 13.867h1.571v1.067H4.714z"
        />
      </g>
      <path
        fill="#28AE67"
        fillRule="evenodd"
        d="M4.714 9.6c.868 0 1.571-.478 1.571-1.067s-.703-1.066-1.571-1.066-1.571.477-1.571 1.066S3.846 9.6 4.714 9.6"
        clipRule="evenodd"
      />
      <mask
        id="dawn-flag-TM_svg__d"
        width={4}
        height={3}
        x={3}
        y={7}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M4.714 9.6c.868 0 1.571-.478 1.571-1.067s-.703-1.066-1.571-1.066-1.571.477-1.571 1.066S3.846 9.6 4.714 9.6"
          clipRule="evenodd"
        />
      </mask>
      <g mask="url(#dawn-flag-TM_svg__d)">
        <path
          fill="#DD404F"
          fillRule="evenodd"
          d="M4.714 9.067c.578 0 1.047-.24 1.047-.534S5.292 8 4.714 8c-.579 0-1.048.239-1.048.533s.469.534 1.048.534"
          clipRule="evenodd"
        />
      </g>
      <path
        fill="#28AE67"
        fillRule="evenodd"
        d="M4.714 11.733c.868 0 1.571-.238 1.571-.533 0-.294-.703-.533-1.571-.533s-1.571.239-1.571.533.703.533 1.571.533"
        clipRule="evenodd"
      />
      <mask
        id="dawn-flag-TM_svg__e"
        width={4}
        height={2}
        x={3}
        y={10}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M4.714 11.733c.868 0 1.571-.238 1.571-.533 0-.294-.703-.533-1.571-.533s-1.571.239-1.571.533.703.533 1.571.533"
          clipRule="evenodd"
        />
      </mask>
      <path
        fill="#FBAF29"
        fillRule="evenodd"
        d="M4.714 6.4c.868 0 1.571-.478 1.571-1.067s-.703-1.066-1.571-1.066-1.571.477-1.571 1.066S3.846 6.4 4.714 6.4"
        clipRule="evenodd"
      />
      <mask
        id="dawn-flag-TM_svg__f"
        width={4}
        height={3}
        x={3}
        y={4}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M4.714 6.4c.868 0 1.571-.478 1.571-1.067s-.703-1.066-1.571-1.066-1.571.477-1.571 1.066S3.846 6.4 4.714 6.4"
          clipRule="evenodd"
        />
      </mask>
      <g mask="url(#dawn-flag-TM_svg__f)">
        <path
          fill="#DD404F"
          fillRule="evenodd"
          d="M4.714 5.867c.29 0 .524-.24.524-.534a.53.53 0 0 0-.524-.533.53.53 0 0 0-.524.533c0 .295.235.534.524.534"
          clipRule="evenodd"
        />
        <path
          fill="#28AE67"
          d="M3.143 4.267h1.048V6.4H3.143zM5.238 4.267h1.048V6.4H5.238z"
        />
      </g>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M11.646 3.39a.54.54 0 0 0 .065.752c.221.19.552.16.738-.066a.54.54 0 0 0-.065-.751.517.517 0 0 0-.738.065M10.29 5.458a.517.517 0 0 0-.738.066.54.54 0 0 0 .065.751c.221.19.552.16.738-.066a.54.54 0 0 0-.065-.75M9.241 4.391a.517.517 0 0 0-.738.066.54.54 0 0 0 .065.752c.222.189.552.16.738-.066a.54.54 0 0 0-.065-.752m2.096-2.133a.517.517 0 0 0-.738.066.54.54 0 0 0 .064.751c.222.19.552.16.738-.066a.54.54 0 0 0-.064-.75m-.524 1.6a.517.517 0 0 0-.738.066.54.54 0 0 0 .064.751c.222.19.552.16.738-.066a.54.54 0 0 0-.064-.75"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M13.73 7.56a3.155 3.155 0 0 1-4.518 0 3 3 0 0 1-.327-.39 3.15 3.15 0 0 0 4.135-.333 3.3 3.3 0 0 0 .328-4.21q.201.148.383.333a3.295 3.295 0 0 1 0 4.6"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagTM;
